import { useState, useEffect } from 'react';
import contentService from '../services/contentService';

/**
 * Custom hook untuk fetch content satu menu
 * 
 * @param {string} menuName - 'homepage', 'about-us', etc
 * @param {boolean} published - only published content
 * @returns {object} { sections, loading, error, refetch }
 */
export function useMenuContent(menuName, published = true) {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchContent = async () => {
    if (!menuName) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const data = await contentService.getMenuContent(menuName, published);
      setSections(data);
      setError(null);
      console.log(`[useMenuContent] ✓ Loaded ${menuName}:`, data.length, 'sections');
    } catch (err) {
      console.error(`[useMenuContent] Failed to load ${menuName}:`, err);
      setError(err.message);
      setSections([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, [menuName, published]);

  return {
    sections,
    loading,
    error,
    refetch: fetchContent
  };
}

export default useMenuContent;
